class RandomService {
  public static generateUniqId() {
    return crypto.getRandomValues(new Uint32Array(1))[0].toString(16);
  }
}

export default RandomService;
